module.exports = __webpack_public_path__ + "static/scale-model-of-esther-beach-park-in-madison-wisconsin-f96a519f2063185144867ade99a9dedc.png";